<i18n lang='yml' src='../i18n/ExamTypeForm.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          {{type == 'new' ? `${$t('new_header')}` : `${$t('edit_header')}`}}
        </h4>
      </div>
    </div>
    <flash :message_type="message_type" :message_text="message_text"/>
      <p class="border-bottom">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']"/>
        <span v-if="type == 'edit'">
          {{ $t('description_edit') }}
        </span>
        <span v-else>
          {{$t('description_new')}}
        </span>
      </p>

      <Form v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
          <fieldset class="form-group border-bottom mt-4">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12 col-lg-9">
                    <Field :name="$t('name_en.label')" v-model="examType.name.en" rules="required" v-slot="{ errors, field }">
                      <label :for="$t('name_en.label')"> 
                        {{$t('name_en.label')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('name_en.label')" 
                        name="name_en"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field"
                        type="text">
                      <div class="invalid-feedback" id="name_en_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>
              
                <div class="form-group row">
                  <div class="col-md-12 col-lg-9">
                     <Field :name="$t('name_fr.label')" rules="required" v-slot="{ errors, field }" v-model="examType.name.fr">
                      <label :for="$t('name_fr.label')"> 
                        {{$t('name_fr.label')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('name_fr.label')" 
                        name="name_fr"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="text">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-5 col-xl-4">
                     <Field :name="$t('max_retries')" rules="required|greater_than_zero|numeric" v-slot="{ errors, field }" v-model="examType.max_retries">
                      <label :for="$t('max_retries')"> 
                        {{$t('max_retries')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('max_retries')" 
                        name="max_retries"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="number">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-5 col-xl-4">
                     <Field 
                      v-model="examType.time_between_retries" 
                      :name="$t('time_between_retries')" 
                      rules="required|greater_than_zero|numeric" 
                      v-slot="{ errors, field }"
                     >
                      <label :for="$t('time_between_retries')"> 
                        {{$t('time_between_retries')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('time_between_retries')" 
                        name="time_between_retries"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="number">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-5 col-xl-4">
                     <Field v-model="examType.pass_mark" :name="$t('pass_mark')" rules="required|greater_than_zero|numeric" v-slot="{ errors, field }">
                      <label :for="$t('pass_mark')"> 
                        {{$t('pass_mark')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('pass_mark')" 
                        name="pass_mark"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="number">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>
                <!-- Disabling fee for now and putting the rules here -->
                <!-- rules="required|integer|greater_than_zero|decimal_places:2"   -->
                <div class="form-group row" v-show="false">
                  <div class="col-md-12 col-lg-5 col-xl-4">
                    <Field
                      :name="$t('current_fee')"
                      v-slot="{ errors, field }">
                      <label :for="$t('current_fee')">
                        {{$t('current_fee')}}
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('current_fee')"
                        name="current_fee"
                        class="form-control"
                        disabled="true"
                        :class="{'is-invalid': errors[0]}"
                        v-bind="field">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span>
                      </div>
                    </Field>   
                  </div>
                </div>
                <!-- Commenting this for now as apparently STO doesn't use it at the moment but leaving it in just in case they want it again -->
                <!-- <div class="form-group">
                  <label>{{$t('scheduled_online')}}</label>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" >
                        <input type="radio" :id="`${$t('scheduled_online')}_true`" :aria-checked="`${$t('scheduled_online')}_true`" value="true" v-model="examType.scheduled_online" >
                        {{$t('yes_val')}}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input type="radio" :id="`${$t('scheduled_online')}_false`" :aria-checked="`${$t('scheduled_online')}_false`" value="false" v-model="examType.scheduled_online" >
                        {{$t('no_val')}}</label>
                    </div>
                  </div>
                </div> -->

                <div class="form-group">
                  <label>{{$t('inventory_required')}}</label>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" >
                        <input type="radio" :id="`${$t('inventory_required')}_true`" :aria-checked="`${$t('inventory_required')}_true`" value="true" v-model="examType.inventory_required" >  {{$t('yes_val')}}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input type="radio" :id="`${$t('inventory_required')}_false`" :aria-checked="`${$t('inventory_required')}_false`" value="false" v-model="examType.inventory_required" >
                      {{$t('no_val')}}</label>
                      </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-9">
                     <Field v-model="examType.required_resources" :name="$t('required_resources.label')" rules="required" v-slot="{ errors, field }">
                      <label :for="$t('required_resources.label')"> 
                        {{$t('required_resources.label')}} 
                      </label>
                      <span class="red">*</span>
                      <textarea 
                        :id="$t('required_resources.label')"  
                        name="required_resources" 
                        :class="{'is-invalid': errors[0]}" 
                        rows="6" class="form-control" 
                        v-bind="field">
                      </textarea>
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-5 col-xl-4">
                     <Field 
                     v-model="examType.time_allowance" 
                     :name="$t('time_allowance')"  rules="required|greater_than_zero|decimal_places:2" 
                     v-slot="{ errors, field }">
                      <label :for="$t('time_allowance')"> 
                        {{$t('time_allowance')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('time_allowance')" 
                        name="time_allowance"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-5 col-xl-4">
                     <Field v-model="examType.number_of_questions" :name="$t('number_of_questions')" rules="required|greater_than_zero|numeric" v-slot="{ errors, field }">
                      <label :for="$t('number_of_questions')"> 
                        {{$t('number_of_questions')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('number_of_questions')" 
                        name="number_of_questions"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="number">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group">
                  <label>{{$t('visible_to_exam_challengers')}}</label>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" >
                        <input type="radio" :id="`${$t('visible_to_challengers')}_true`" :aria-checked="`${$t('visible_to_challengers')}_true`" value="true" v-model="examType.visible_to_challengers" >
                        {{$t('yes_val')}}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input type="radio" :id="`${$t('visible_to_challengers')}_false`" :aria-checked="`${$t('visible_to_challengers')}_false`" value="false" v-model="examType.visible_to_challengers" >
                        {{$t('no_val')}}</label>
                    </div>
                  </div>
                </div>


                <div class="form-group row">
                  <div class="col-md-12 col-lg-5">
                     <Field :name="$t('status')"  rules="select_option" v-slot="{ errors, field }" v-model="examType.status">
                      <label :for="$t('status')"> 
                        {{$t('status')}} 
                      </label>
                      <span class="red">*</span>
                      <select  
                        v-bind="field" 
                        :id="examType.status" 
                        class="form-control"
                         :class="{'is-invalid': errors[0]}" >
                        <option v-for="status in statusData" :key="status.name" :value="status.name">
                          {{$t(`${status.value}`)}}
                        </option>
                      </select>
                
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>
                  </div>
                </div>


              </div>

            </div>
          </fieldset>

          <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>

          <div class="btn-row d-flex">
            <button type="submit" class="btn btn-primary btn-success no-shadow" v-if="type=='new'">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{ $t('create') }}
            </button>
            <template v-else>
              <button  type="submit" :data-confirm="$t('confirm_update')" class="btn btn-primary btn-success no-shadow">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('submit') }}
              </button>
              <a class="btn btn-danger" v-if="!hide_delete" :data-confirm="$t('confirm_delete')" data-method="delete" :href="buildDeleteUpdatePath(examType.id)">
                <font-awesome-icon :icon="['fa', 'trash-alt']" />
                {{ $t('delete_exam_type') }}
              </a>
            </template>
              <a class="btn btn-light ml-auto" :href="base_path">
              <font-awesome-icon :icon="['fa', 'times']" />
              {{ $t('cancel') }}
            </a>
          </div>
      </Form>
  </div>
</template>

<script>
import flash from '../../../../shared/flash_messages/components/Flash.vue';
import '../../../../../javascripts/application/vee-validate-rules.js'
import { sendAjaxRequest, ajaxResponseMessage } from '../../../../shared/typescripts/ajax.ts'
import { setErrorMessage } from '../../../../shared/typescripts/error.ts'

import { Form, Field } from 'vee-validate';
export default {
  props: ['locale', 'exam_type', 'base_path', 'type', 'statuses', 'hide_delete', 'default_exam_fee'],

  components: {
     flash,
     Form,
     Field
  },
  data() {
    return {
      examType: {
        name: {},
        max_retries: null,
        pass_mark: null,
        current_fee: 0,
        inventory_required: false,
        number_of_questions: null,
        required_resources: "",
        scheduled_online: false,
        time_between_retries: null,
        time_allowance: null,
        status: 'active',
        visible_to_challengers: false
      },
      message_type: "",
      message_text: [],
      statusData: [],
      showErrorBanner: false
    }
  },
  created() {
    this.$i18n.locale = this.locale;
  },

  mounted() {
    this.statusData = JSON.parse(this.statuses)
    this.examType.current_fee = 0//this.default_exam_fee

    try {
      this.examType = JSON.parse(this.exam_type)
      this.examType.current_fee = 0//this.default_exam_fee
      if(this.examType.name == null){
        this.examType.name = {}
        
      }
    }
    catch(err) {
      this.error = true; 
    } 
  },

  methods: {
    buildDeleteUpdatePath(id){
      let path = `${this.base_path}/${id}`
      return path
    },

    setErrorMessage({ valuese, errors, results }) {
      setErrorMessage(this, errors, true)
    },

    submitUserInput(event){
      let payload = []
      
      payload = { exam_type: this.examType }

      this.message_text = [];
      let send_type = 'POST'
      let path = this.base_path

      if (this.type == "edit") {
        send_type = "PUT"
        path = this.buildDeleteUpdatePath(this.examType.id)
      }

      sendAjaxRequest(send_type, path, 'json', payload, ajaxResponseMessage, this.throwError)
      
    },
    
    throwError() {
      console.log("Error")
    }
  }
}
</script>
